import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { StaffById } from '../interfaces/staff.interface';
import { environment } from '../../../../../apps/ff-frontend/src/environments/environment';
import { NotFoundError } from 'libs/errors/src/lib/not-found.error';
import { AppErrors } from 'libs/errors/src/lib/app.errors';

@Injectable({
  providedIn: 'root'
})
export class StaffService {
  private readonly API_URL = environment.BASE_URL;
  private staffSubject = new BehaviorSubject<StaffById | null>(null);
  public staff$ = this.staffSubject.asObservable();

  constructor(private http: HttpClient) {}

  getStaffDetails(staffId: number): Observable<StaffById> {
    return this.http.get<StaffById>(`${this.API_URL}/staff/${staffId}`).pipe(
      tap(staff => this.staffSubject.next(staff))
    );
  }

  updateStaffDetails(staffId: number, data: any): Observable<StaffById> {
    return this.http.patch(`${this.API_URL}/staff`, data).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) return throwError(() => new NotFoundError(error));
        return throwError(() => new AppErrors(error));
      })
    );
  }

  updateStaffPicture(staffId: number, file: File): Observable<StaffById> {
    const formData = new FormData();
    formData.append('picture', file);
    
    return this.http.post<StaffById>(`${this.API_URL}/staff/${staffId}/picture`, formData).pipe(
      tap(staff => this.staffSubject.next(staff))
    );
  }

  changePassword(staffId: number, data: { currentPassword: string; newPassword: string }): Observable<void> {
    return this.http.post<void>(`${this.API_URL}/staff/${staffId}/change-password`, data);
  }

  updateThemePreference(staffId: number, theme: string): Observable<void> {
    return this.http.post<void>(`${this.API_URL}/staff/${staffId}/theme`, { theme });
  }

  patchStaffDetails(data: any): Observable<void> {
    return this.http.patch<void>(`${this.API_URL}/me`, data);
  }
} 